module.exports = __webpack_public_path__ + "assets/img/844ba1592fa2d4408892d3398087698b.svg";